<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>Alumni Association Request </strong>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <table class="table table-bordered">
            <tr>
              <th>Field</th>
              <th>Old Value</th>
              <th>New Value</th>
            </tr>
            <tr v-for="(range, name) in collegeAlumniFieldRequest" :key="name">
              <td>{{range.field}}</td>
              <td v-if="range.old_value == ''">-</td>
              <td v-if="range.old_value != ''">{{range.old_value}}</td>
              <td>{{range.value}}</td>
            </tr>
            <tr>
              <th>Status </th>
              <td colspan="2">
                <v-select v-if="alumni.status == 0" :options="statusList" v-model="status"></v-select>
                <span v-if="alumni.status == 1">Approved</span>
                <span v-if="alumni.status == 2">Rejected</span>
              </td>
            </tr>
            <tr v-if="alumni.status == 2 || status.value == 2">
              <th>Reason </th>
              <td colspan="2">
                <input type="text" v-if="alumni.reason == null" v-model="reason" class="form-control"/>
                <span v-if="alumni.reason != null">{{alumni.reason}}</span>
              </td>
            </tr>
            <tr v-if="alumni.status == 0">
              <td colspan="3">
                <CButton
                    type="submit"
                    size="sm"
                    color="primary"
                    @click="OnSubmit"
                >
                  <CIcon name="cil-check-circle"/>
                  {{ $lang.buttons.general.crud.submit }}
                </CButton>
              </td>
            </tr>
          </table>
<!--          <table class="table table-bordered">-->
<!--            <tr>-->
<!--              <th>Association Name</th>-->
<!--              <td>{{alumni.association_name}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.registration_number">-->
<!--              <th>Registration Number </th>-->
<!--              <td>{{alumni.registration_number}}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <th>Mobile </th>-->
<!--              <td>{{alumni.countryCode}}{{alumni.mobile_no}}</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <th>Email </th>-->
<!--              <td>{{alumni.email}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.address">-->
<!--              <th>Address </th>-->
<!--              <td>{{alumni.address}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.status">-->
<!--              <th>Status </th>-->
<!--              <td v-if="alumni.status == 0">Pending</td>-->
<!--              <td v-if="alumni.status == 1">Approved</td>-->
<!--              <td v-if="alumni.status == 2">Rejected</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.website">-->
<!--              <th>Website </th>-->
<!--              <td>{{alumni.website}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.description">-->
<!--              <th>Description </th>-->
<!--              <td>{{alumni.description}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.institute_name">-->
<!--              <th>Institute Name </th>-->
<!--              <td>{{alumni.institute_name}}</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.institute_type">-->
<!--              <th>Institute Type </th>-->
<!--              <td v-if="alumni.institute_type == 1">College</td>-->
<!--              <td v-if="alumni.institute_type == 2">School</td>-->
<!--            </tr>-->
<!--            <tr>-->
<!--              <th>Is Registered? </th>-->
<!--              <td v-if="alumni.is_registered == 0">No</td>-->
<!--              <td v-if="alumni.is_registered == 1">Yes</td>-->
<!--            </tr>-->
<!--            <tr v-if="alumni.created_by_type">-->
<!--              <th>Created By Type </th>-->
<!--              <td>{{alumni.created_by_type}}</td>-->
<!--            </tr>-->
<!--          </table>-->
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import {alumniRequest} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";
import store from "@/store/store";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "AlumniRequest",
  mixins: [Mixin],
  components: {},
  data() {
    return {
      status: {'value':"","label":""},
      reason:"",
      submitted: false,
      json_data: [],
      json_label: {},
      messageColor: "success",
      json_title: "",
      err_msg: "",
      largeModal: false,
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: alumniRequest,
      collegeAlumniFieldRequest: [],
      alumni: {},
      maxlength: {
        title: Maxlength.alumni.title,
      },
      columns: ["associationName", "address","isRegistered","email","status", "actions"],
      statusList: [
        {
          "value" : 1,
          "label" : "Approve",
        },
        {
          "value" : 2,
          "label" : "Reject",
        },
      ],
      data: [],
      options: {
        headings: {
          associationName: "Title",
          email: "Email",
          status: "status",
          isRegistered: "Is Registered",
          address: "Address",
          actions: "Actions",
        },
        editableColumns: ["title"],
        sortable: ["title", "status"],
        filterable: ["title", "status"],
      },
    };
  },
  validations: {
    alumni: {
      title: {
        required,
        minLength: minLength(1),
      },
    },
  },
  mounted() {
    let self = this;
    this.loadData();
    store.commit('showLoader', false);
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.alumni.isActive = 1;
      } else {
        self.alumni.isActive = 0;
      }
    },
    setAlert(value) {
      this.showAlert = value;
    },
    loadData() {
      let self = this;
      axios.post(this.viewUrlApi(this.module), {'id' : this.$route.params.id})
          .then(function (response) {
            if (response) {
              self.collegeAlumniFieldRequest = response.data.data.collegeAlumniFieldRequest;
              self.alumni = response.data.data;
            }
          });
    },
    OnSubmit() {
      setTimeout(() => {
        let self = this;
        const postData = {
          isActive: self.status.value,
          reason: self.reason,
          id: this.$route.params.id,
        };
        axios.post('alumni/request/status', postData)
            .then(function (response) {
              self.submitted = false; //Enable Button
              if (response.data.code == 200) {
                self.largeModal = false;
                self.alertMessage = response.data.message;
                self.messageColor = "success";
                self.dismissCountDownS = 10;
                self.$router.push({name: "Alumni Request"});
              } else {
                self.err_msg = response.data.message;
                self.dismissCountDown = 10;
              }
            })
            .catch(function (error) {
              let data;
              if (error.response.data.error) {
                data = error.response.data.error.toString();
              } else {
                data = error.response.data.message;
              }
              self.err_msg = data;
              self.dismissCountDown = 10;
              self.submitted = false; //Enable Button
            });
      }, 500);
    },
  },
};
</script>
